var _defs, _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMassSendToSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.52 43.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.46 23.139H11.123a7.412 7.412 0 00-7.412 7.412v1.402"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.677 38.55s.833-2.485 2.351-1.766c1.845.873.585 3.731 3.004 3.458 1.352-.152 1.905-2.419 1.975-1.785.105.96 2.169 1.112 2.169 1.112M27.1 28.026l9.309-9.308 4.338 4.339-9.308 9.308-6.204 1.865 1.865-6.204zM27.1 28.026l4.339 4.339"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 30.448,
    cy: 40.848,
    r: 1.416
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 17.791,
    cy: 13.443,
    r: 7.803
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassSendToSign);
export default __webpack_public_path__ + "static/media/massSendToSign.d5731eca2823e47d2bd4620ab9507f75.svg";
export { ForwardRef as ReactComponent };